import React, { useState, useEffect, useRef } from 'react';
import { dompurifier } from '@nile/components/src/Utils/helpers';

const VirtualizedHtml = ({ rawHtml = '' }) => {
  const [sanitizedHtml, setSanitizedHtml] = useState('');

  useEffect(() => {
    if (rawHtml) {
      let htmlDataToDisplay = dompurifier(rawHtml, {
        FORBID_TAGS: ['style']
      });

      htmlDataToDisplay = htmlDataToDisplay.replaceAll(
        '<img',
        "<img loading='lazy'"
      );
      setSanitizedHtml(htmlDataToDisplay);
    }
  }, [rawHtml]);

  return (
    <p
      dangerouslySetInnerHTML={{
        __html: sanitizedHtml
      }}
    />
  );
};

export default VirtualizedHtml;
